import Config from "@/components/settings/config/Config";
import GoogleAccount from "@/components/settings/googleAccount/GoogleAccount";
import DemandCountries from "@/components/settings/demandCountries/DemandCountries";
import Countries from "@/components/settings/countries/countries";
import EmailAlert from "@/components/settings/emailAlert/EmailAlert";
import Languages from "@/components/settings/languages/languages";

export const settings = [
    {path: '/config', name: 'settings', component: Config},
    {path: '/google-accounts', name: 'googleAccount', component: GoogleAccount},
    {path: '/demand-countries', name: 'demandCountries', component: DemandCountries},
    {path: '/email-alert', name: 'emailAlert', component: EmailAlert},
    {path: '/countries', name: 'countries', component: Countries},
    {path: '/languages', name: 'languages', component: Languages},
]